<template>
  <div id="consumeRecord">
    <div class="rightHead">
      <div
        style="margin:0 0 0 30px;font-size:15px;padding-top:16px;color:#707070;"
        v-if="$route.meta.titleShow"
      >
        {{ $route.name }}
      </div>
    </div>
    <div class="invoicingHead" style="height: 40px">
      <el-breadcrumb class="elArrowText" separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>会员消费记录</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="searchGroup">
      <div class="row">
        <span class="phone">手机号</span>
        <el-input
          placeholder="请输入手机号"
          v-model="phoneNum"
          style="width:220px;margin-right:20px;"
          @blur="phoneNumBlur"
        ></el-input>
        <el-select
          v-model="value"
          placeholder="请选择"
          class="pr30"
          @change="styleChange"
        >
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <el-button type="primary" size="small" @click="search">查询</el-button>
      </div>
      <div class="row" style="padding-top:25px;">
        <div class="pr30">营销统计</div>
        <div class="pr30 bold">
          充值总金额：
          <span class="colorblue">{{ total_recharge }}</span> 元
        </div>
        <div class="pr30 bold">
          总余额：
          <span class="color-orange">{{ total_member_balance }}</span> 元
        </div>
        <div class="pr30 bold">
          消费总额：
          <span class="colorblue">{{ total_consume }}</span> 元
        </div>
        <div class="pr30 bold">
          会员总数：
          <span class="color-orange">{{ total_member_num }}</span> 人
        </div>
      </div>
      <div class="table-content">
        <el-table
          :data="tableData"
          style="width: 100%"
          v-loading="loading"
          element-loading-background="rgba(0, 0, 0, 0.3)"
          element-loading-text="数据正在加载中"
          element-loading-spinner="el-icon-loading"
        >
          <el-table-column align="center" prop="useType" label="类型">
            <template slot-scope="scope">
              {{
                scope.row.useType == 1
                  ? "充值"
                  : scope.row.useType == 2
                  ? "消费"
                  : ""
              }}
            </template>
          </el-table-column>
          <el-table-column align="center" prop="phoneNum" label="手机号" />
          <el-table-column align="center" prop="createTime" label="时间" />
          <el-table-column align="center" prop="shopName" label="店铺名称" />
          <el-table-column align="center" prop="tranMoney" label="金额（元）">
            <template slot-scope="scope">
              <div class="green-color" v-if="scope.row.useType == 1">
                +{{ scope.row.tranMoney.toFixed(2) }}
              </div>
              <div class="red-color" v-if="scope.row.useType == 2">
                -{{ scope.row.tranMoney.toFixed(2) }}
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div
          v-if="tableData.length > 0"
          class="block"
          style="float:right;margin-top:10px;"
        >
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page="queryInfo.pageNo"
            :page-size="queryInfo.row"
            layout="total, prev, pager, next, jumper"
            :total="total"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { rechargeConsumList } from "../api/index";
export default {
  data() {
    return {
      phoneNum: "",
      tableData: [],
      loading: false,
      queryInfo: {
        pageNo: 1,
        row: 10
      },
      total: 0,
      status: "",
      userList: {},
      value: "",
      options: [
        { value: "", label: "全部" },
        { value: "1", label: "充值" },
        { value: "2", label: "消费" }
      ],
      total_recharge: 0,
      total_member_balance: 0,
      total_consume: 0,
      total_member_num: 0
    };
  },
  created() {
    let userList = JSON.parse(this.getCookie("userList"));
    this.userList = userList;
    this.getRechargeConsumList();
  },
  methods: {
    getRechargeConsumList(useType, phoneNum) {
      this.loading = true;
      rechargeConsumList({
        sessionId: this.userList.sessionId,
        userId: this.userList.id,
        pageNumber: this.queryInfo.pageNo,
        pageSize: this.queryInfo.row,
        phoneNum: phoneNum,
        useType: useType
      }).then(res => {
        this.loading = false;
        if (res.code == 1) {
          this.tableData = res.data.pager.list;
          this.total = res.data.pager.totalCount;
          this.total_recharge = res.data.shopMemberDataDto.total_recharge;
          this.total_member_balance =
            res.data.shopMemberDataDto.total_member_balance;
          this.total_consume = res.data.shopMemberDataDto.total_consume;
          this.total_member_num = res.data.shopMemberNum.total_member_num;
        } else if (res.code == -1) {
          this.tableData = [];
        } else if (res.code == 2) {
          this.$message.error(res.msg);
          this.$router.push("/");
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    handleCurrentChange(val) {
      this.queryInfo.pageNo = val;
      if (this.status == 1) {
        this.getRechargeConsumList(this.value, this.phoneNum);
      } else {
        this.getRechargeConsumList();
      }
    },
    search() {
      this.status = 1;
      this.queryInfo.pageNo = 1;
      this.getRechargeConsumList(this.value, this.phoneNum);
    },
    phoneNumBlur() {
      if (!this.phoneNum) {
        this.getRechargeConsumList();
      }
    },
    styleChange(val) {
      this.getRechargeConsumList(val, this.phoneNum);
    }
  }
};
</script>

<style lang="scss" scoped>
.pr30 {
  padding-right: 30px;
  box-sizing: border-box;
}
.colorblue {
  color: #3388ff;
}
.red-color {
  color: red;
}
.green-color {
  color: green;
}
.bold {
  font-weight: bold;
  .color-orange {
    color: #ff7757;
  }
}
#consumeRecord {
  width: calc(100vw - 217px);
  height: calc(100vh);
  margin-left: 200px;
  min-width: 1340px;
  .searchGroup {
    width: 100%;
    padding-top: 120px;
    padding-left: 20px;
    box-sizing: border-box;
    .row {
      .phone {
        padding: 8px 10px 0 0;
      }
    }
    .table-content {
      width: calc(100vw - 280px);
      padding-top: 40px;
      box-sizing: border-box;
    }
  }
}
::v-deep .el-table th {
  background: #f8f8f8;
}
</style>



// WEBPACK FOOTER //
// src/components/page/consumeRecord.vue